var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"optionFilterItem",on:{"click":_vm.selectedOption}},[_c('div',{staticClass:"inputCheckbox",class:{active: _vm.activeOption}}),_c('p',[_vm._v(_vm._s(_vm.$props.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }